import { CustomTitleWithDropDown } from "components/customer/CustomTitleWithDropDown";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { createAction } from "utils";
import { hasError, ReactHookFormErrorMessage } from "./ErrorFieldMessage";
import BasePrompt from "./prompt/BasePrompt";

const CustomDropdownWithButtonAndPrompt = ({
  title,
  description,
  placeholder,
  dropDownSearchBarPlaceholder,
  bottomTips = "",
  labelContainPk = true,
  titleStyle,
  defaultValue,
  setValue = () => { },
  source,
  hasAddButton,
  addButtonInfo,
  onFocus = () => { },
  errors,
  formErrorId,
  promptConfig,
  loadMoreAction,
  filterAction,
  defaultFilter = {},
  disabled,
  disableDropDown,
}) => {
  const dispatch = useDispatch();

  const [refreshDate, setRefreshDate] = useState(new Date());
  const [lastRefreshDate, setLastRefreshDate] = useState(refreshDate);
  const [showCreateNewLinkPrompt, setShowCreateNewLinkPrompt] = useState(false);

  useEffect(() => {
    dispatch(
      createAction(loadMoreAction)(defaultFilter),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshDate]);

  return (
    <>
      <CustomTitleWithDropDown
        customClass={hasError(errors, formErrorId) ? "error-field" : ""}
        title={title}
        description={description}
        titleStyle={titleStyle}
        defaultValue={defaultValue}
        placeholder={placeholder}
        dropDownSearchBarPlaceholder={dropDownSearchBarPlaceholder}
        setValue={setValue}
        source={source}
        labelContainPk={labelContainPk}
        loadMoreAction={loadMoreAction}
        filterAction={filterAction}
        defaultFilter={defaultFilter}
        addButtonInfo={hasAddButton && addButtonInfo ? {
          ...addButtonInfo,
          action: () => {
            setShowCreateNewLinkPrompt(true)
            addButtonInfo?.action && addButtonInfo.action()
          }
        } : {}}
        onFocus={onFocus}
        isReset={lastRefreshDate !== refreshDate}
        resetChange={() => {
          setLastRefreshDate(refreshDate);
        }}
        bottomTips={bottomTips}
        disabled={disabled}
        disableDropDown={disableDropDown}
      />
      <ReactHookFormErrorMessage errors={errors} id={formErrorId} />

      {hasAddButton && promptConfig &&
        <BasePrompt
          show={showCreateNewLinkPrompt}
          closeAction={() => setShowCreateNewLinkPrompt(false)}
          leftButton={{
            text: promptConfig.refreshButton,
            action: () => {
              setRefreshDate(new Date());
              setShowCreateNewLinkPrompt(false);
            },
          }}
          rightButton={{
            text: promptConfig.button,
            action: promptConfig.action,
          }}
          title={promptConfig.title}
          description={
            promptConfig.message
          }
        />}
    </>
  );
}

export default CustomDropdownWithButtonAndPrompt;